<svg class="chord" xmlns="http://www.w3.org/2000/svg"
  *ngIf="graph && chordConfig && fingerPlacement.length"
  [attr.width]="size" [attr.height]="size * height / width"
  [attr.viewBox]="'0 0 ' + width + ' ' + height" >

  <g class="generic">
    <!-- <rect class="frame" x="0" y="0" [attr.width]="width" [attr.height]="height" /> -->
    <text x="10" y="10">{{name}}</text>
  </g>
  <g class="strings">
    <ng-container *ngFor="let stringNr of strings;let stringIndex = index">
      <line class="string"
        [attr.x1]="stringOffset + stringIndex * stringSpace" [attr.x2]="stringOffset + stringIndex * stringSpace"
        [attr.y1]="stringOffset" [attr.y2]="height" />
      <circle class="string"
        [attr.cx]="stringOffset + stringIndex * stringSpace"
        [attr.cy]="fretOffset / 2"
        [attr.r]="fretOffset / 3" />
      <text class="string" [attr.x]="stringOffset + stringIndex * stringSpace" [attr.y]="stringOffset / 2">
        {{stringNr}}
      </text>
    </ng-container>
  </g>
  <g class="frets">
    <ng-container *ngFor="let fretNr of frets; let fretIndex = index">
      <line class="fret"
        [attr.x1]="fretOffset" [attr.x2]="stringOffset + stringSpace * (strings.length - 1)"
        [attr.y1]="fretOffset + fretIndex * fretSpace" [attr.y2]="fretOffset + fretIndex * fretSpace" />
      <circle class="fret"
        [attr.cx]="stringOffset / 2"
        [attr.cy]="fretOffset + fretSpace / 2 + fretIndex * fretSpace"
        [attr.r]="stringOffset / 3" />
      <text class="fret" [attr.x]="stringOffset / 2" [attr.y]="fretOffset + fretSpace / 2 + fretIndex * fretSpace">
        {{fretNr}}
      </text>
    </ng-container>
  </g>
  <g class="finger">
    <ng-container *ngFor="let placement of fingerPlacement; let fretIndex = index">
      <circle class="finger finger{{placement.finger}} string{{placement.string}} fret{{placement.fret}} signatureindex{{placement.tone}}"
        [attr.cx]="stringOffset + (placement.string) * stringSpace"
        [attr.cy]="fretOffset + fretSpace / 2 + (placement.fret-1) * fretSpace"
        [attr.r]="stringOffset / 3"
        [attr.title]="'asdfasdf'"
      />
      <text *ngIf="placement.note"
        [attr.x]="(stringOffset + (placement.string) * stringSpace) - stringOffset / 3"
        [attr.y]="fretOffset + fretSpace / 2 + (placement.fret-1) * fretSpace + stringOffset / 3"
        [attr.title]="'asdfasdf'"
      >{{placement.note}}</text>
    </ng-container>

  </g>
</svg>
<span class="chord" *ngIf="!graph">{{chord}}</span>
